import { render } from "./distribute-dialog.vue?vue&type=template&id=412cf05b&scoped=true"
import script from "./distribute-dialog.vue?vue&type=script&lang=js"
export * from "./distribute-dialog.vue?vue&type=script&lang=js"

import "./distribute-dialog.vue?vue&type=style&index=0&id=412cf05b&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412cf05b"]])

export default __exports__